module.exports = __webpack_public_path__ + "img/view-sequential.c520d32b.svg";